import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Statement — monthly PDF/XLSX downloads. */
export function StatementIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M7 3.8h6.4L18.5 9v10.4a1.8 1.8 0 0 1-1.8 1.8H7a1.8 1.8 0 0 1-1.8-1.8V5.6A1.8 1.8 0 0 1 7 3.8Z" />
      <path d="M13.2 3.8V9h5.3" />
      <path d="M8.8 12.6l2 2 4.4-4.6" />
    </PortalIcon>
  );
}
